import React from "react";
import {
  Navigate,
} from "react-router-dom";


const QrBatchListComponent = React.lazy(() => import("../../../components/qr-implementation/components/list/page"));


export const qrBatchRoutes = [
  {
    path: 'list',
    element: <QrBatchListComponent />,
  },
  
  {
    path: '',
    element: <Navigate replace to="/qr-batch/list" />
  },
]